import { useParsed } from '@refinedev/core';
import { useEffect } from 'react';
import { Params } from 'react-router-dom';
import { useDetections } from 'src/data-capture/hooks/file-uploads/useDetections';
import { useDetectedEntitiesStore } from 'src/data-capture/stores/useDetectedEntitiesStore';
import { useFileUpload } from './useFileUpload';

type UseFileUploadWithEntitiesProps = {
  autoRefreshProcessing?: boolean;
};

export function useFileUploadWithEntities({
  autoRefreshProcessing = false,
}: UseFileUploadWithEntitiesProps = {}) {
  const { params } = useParsed<Params>();
  const fileId = params?.fileId ?? '';

  const { handleDetectionData } = useDetectedEntitiesStore();

  const {
    file,
    isLoading: isFileLoading,
    error: fileError,
    setFileResolved,
  } = useFileUpload(fileId, { autoRefreshProcessing });

  const {
    detections,
    isLoading: isDetectLoading,
    isFetching: isDetectFetching,
    error: detectError,
    refetchDetections,
  } = useDetections({
    fileId: file?.id,
  });

  useEffect(() => {
    if (file != null) {
      handleDetectionData(file.id, detections);
    }
  }, [isDetectFetching]);

  const isLoading = isFileLoading || isDetectLoading;
  const error = fileError || detectError;

  const refetch = async () => {
    await refetchDetections();
  };

  return {
    file,
    isLoading,
    error,
    refetch,
    setFileResolved,
  };
}
